<template>
    <v-card>
        <v-card-title>会員一覧</v-card-title>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex v-if="isSearching()">
                    <v-btn class="primary mr-2" @click="openDialog">検索</v-btn>
                    <v-btn class="error mr-2" @click="resetSearch">検索リセット</v-btn>
                </v-flex>
                <v-flex v-else>
                    <v-btn @click="openDialog">検索</v-btn>
                </v-flex>
                <v-flex class="text-right" v-if="canCreate()">
                    <v-btn class="info" to="/customer/add">新規登録</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="customers"
                :loading="loading"
                hide-default-footer
                :items-per-page="conditions.perPage"
                class="elevation-1"
            >
                <template v-slot:[`item.course`]="{ item }">
                    {{ showCourse(item.course) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    {{ showStatus(item.status) }}
                </template>
                <template v-slot:[`item.address`]="{ item }">
                    {{ showPrefecture(item.pref) }}{{ item.address }}
                </template>
                <template v-slot:[`item.age`]="{ item }">
                    {{calcAge(item.birthday)}}歳
                </template>
                <template v-slot:[`item.gender`]="{ item }">
                    {{CUSTOMER.GENDER.getName(item.gender)}}
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-btn fab small dark class="info mr-2" :to="`/customer/${item.id}`" target="_blank">
                        カルテ
                    </v-btn>
                    <v-btn fab small dark class="info mr-2" :to="`/customer/history/${item.id}`" target="_blank">
                        経緯表
                    </v-btn>
                    <v-btn fab small dark class="edit mr-2" :to="`/customer/edit/${item.id}`" target="_blank">
                        編集
                    </v-btn>
                    <v-btn fab small class="delete" dark @click="deleteConfirm(item.id)" v-if="canDelete()">
                        削除
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination
                v-model="currentPage"
                :length="total"
                @input="reloadList"
            ></v-pagination>
        </v-card-text>

        <v-layout row justify-center>
            <v-dialog v-model="searchDialog" persistent max-width="800px">
                <v-form>
                    <v-card>
                        <v-card-title>
                            <span class="headline">会員検索</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md3 v-if="canSearchAll()">
                                        <v-select
                                            v-model="conditions.shop_id"
                                            :items="searchShops"
                                            label="支店"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.counselor_id"
                                            :items="searchCounselors"
                                            label="担当CO"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.phone_number"
                                            label="電話番号"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.number"
                                            type="number"
                                            label="会員No."
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-text-field
                                            v-model="conditions.name"
                                            label="名前"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.gender"
                                            :items="searchGenders"
                                            label="性別"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.status"
                                            :items="searchStatus"
                                            label="状態"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                    </v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-checkbox
                                            v-model="conditions.is_exit"
                                            label="退会済会員"
                                        ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs0 sm0 md6></v-flex>
                                    <v-flex xs12 sm6 md3>
                                        <v-select
                                            v-model="conditions.perPage"
                                            :items="perPages"
                                            label="件数"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                class="info"
                                @click="search"
                                >検索</v-btn
                            >
                            <v-btn @click="closeDialog">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout row justify-center>
            <v-dialog v-model="deleteDialog" persistent max-width="290px">
                <v-card>
                    <v-card-title> 削除しますか？ </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark class="delete" @click="deleteCustomer"
                            >削除</v-btn
                        >
                        <v-btn @click="deleteClose">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"

export default {
    title: "会員一覧",
    name: "customer_list",
    mixins: [utilDatetime],
    data: () => ({
        CUSTOMER: CUSTOMER,
        customers: [],
        loading: true,
        headers: [
            { text: "名前", value: "name", align: "start", sortable: false, width: "200px" },
            { text: "住所", value: "address", align: "start", sortable: false, width: "200px" },
            { text: "年齢", value: "age", align: "start", sortable: false, width: "100px" },
            { text: "性別", value: "gender", align: "start", sortable: false, width: "100px" },
            { text: "コース", value: "course", align: "start", sortable: false, width: "150px" },
            { text: "状態", value: "status", align: "start", sortable: false, width: "150px" },
            { text: "操作", value: "action", align: "center", sortable: false, width: "216px" },
        ],
        currentPage: 1,
        perPage: 50,
        total: null,
        prefectures: [],
        shops: [],
        conditions: {
            shop_id: 0,
            counselor_id: 0,
            number: "",
            phone_number: "",
            name: "",
            gender: 0,
            status: 0,
            alert: 0,
            is_exit: false,
            perPage: 50,
        },
        searchDialog: false,
        searchShops: [],
        searchCounselors: [],
        searchGenders: [],
        searchStatus: [
            { value: 0, text: "全て" },
            { value: 1, text: "シフト対象者" },
            { value: 2, text: "退会予備状態" },
            { value: 3, text: "退会処理待ち" },
            { value: 4, text: "休止会員" },
        ],
        searchAlert: [
            { value: 0, text: "全て" },
            { value: 1, text: "稼働中のみ" },
            { value: 2, text: "停止中のみ" },
        ],
        perPages: [
            { value: 50, text: "50件" },
            { value: 100, text: "100件" },
            { value: 200, text: "200件" },
        ],
        deleteDialog: false,
        deleteTargetId: 0,
    }),
    async mounted() {
        // 検索条件の読み込み
        this.loadSearchConditions();

        this.currentPage = parseInt(this.$route.query.page || 1);
        await this.loadList();
    },
    async beforeRouteUpdate(to, from, next) {
        this.currentPage = parseInt(to.query.page || 1);
        await this.loadList();
        next();
    },
    methods: {
        async reloadList() {
            const url = `/customer/list?page=${this.currentPage}`;
            this.$router.push(url);
            scrollTo(0, 0);
        },
        async loadList() {
            this.loading = true;
            try {
                const result = await this.$axios
                    .get("/api/v1/customer", {
                        params: {
                            page: this.currentPage,
                            perPage: this.conditions.perPage,
                            shop_id: this.conditions.shop_id,
                            counselor_id: this.conditions.counselor_id,
                            number: this.conditions.number,
                            phone_number: this.conditions.phone_number,
                            name: this.conditions.name,
                            gender: this.conditions.gender,
                            status: this.conditions.status,
                            alert: this.conditions.alert,
                            is_exit: this.conditions.is_exit,
                        }
                    })
                    .then((response) => {
                        return response.data;
                    })
                    .catch((error) => {
                        return error;
                    });

                if (result) {
                    this.customers = result.customers;
                    this.total = result.total;
                    this.shops = result.shops;
                    this.prefectures = result.prefectures;

                    this.searchShops = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.shops.forEach(shop => this.searchShops.push({ value: shop.id, text: shop.name}));
                    this.searchCounselors = [{
                        value: 0,
                        text: "全て"
                    }];
                    result.counselors.forEach(c => this.searchCounselors.push(c));
                    this.searchCounselors.push({ value: -1, text: "未定" });
                    this.searchGenders = [{
                        value: 0,
                        text: "全て"
                    }];
                    CUSTOMER.GENDER.LIST.forEach(g => this.searchGenders.push(g));
                }
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },
        showShopName(shopId) {
            const shop = this.shops.find(shop => shop.id == shopId);
            if(!shop) return '';
            return shop.name;
        },
        showCourse(course) {
            if(!course) return '未契約';
            return `${course.name}(${course.contract_date}～)`
        },
        showStatus(status) {
            const statusStr = ['活動中', '退会予備状態', '休止状態', '退会処理待ち'];
            if(status < 0 || statusStr.length <= status) return '';
            return statusStr[status];
        },
        showPrefecture(pref) {
            const prefecture = this.prefectures.find(prefecture => prefecture.id == pref);
            if(!prefecture) return '';
            return prefecture.name;
        },
        loadSearchConditions() {
            this.conditions = Object.assign({}, this.$store.state.conditions);
        },
        isSearching() {
            if(this.$store.state.conditions.shop_id != 0) return true;
            if(this.$store.state.conditions.counselor_id != 0) return true;
            if(this.$store.state.conditions.number && this.$store.state.conditions.number.length > 0) return true;
            if(this.$store.state.conditions.phone_number && this.$store.state.conditions.phone_number.length > 0) return true;
            if(this.$store.state.conditions.name && this.$store.state.conditions.name.length > 0) return true;
            if(this.$store.state.conditions.gender != 0) return true;
            if(this.$store.state.conditions.status != 0) return true;
            if(this.$store.state.conditions.alert != 0) return true;
            if(this.$store.state.conditions.is_exit) return true;
            return false;
        },
        search() {
            this.$store.dispatch("setCustomerSearchConditions", this.conditions);
            this.closeDialog();
            this.$router.go({path: "/customer/list", force: true})
        },
        resetSearch() {
            this.conditions = {
                shop_id: 0,
                counselor_id: 0,
                number: "",
                phone_number: "",
                name: "",
                gender: 0,
                status: 0,
                alert: 0,
                is_exit: false,
                perPage: 50,
            };
            this.search();
        },
        openDialog() {
            this.loadSearchConditions();
            this.searchDialog = true;
        },
        closeDialog() {
            this.searchDialog = false;
        },
        canCreate() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_CREATE) return true;
            return false;
        },
        canDelete() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_DELETE) return true;
            return false;
        },
        canSearchAll() {
            const self = this.$store.state.user;

            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if(self.privilege & ACCOUNT.PRIVILEGE.VAL.CUSTOMER_ALL) return true;
            return false;
        },
        deleteConfirm(id) {
            this.deleteTargetId = id;
            this.deleteDialog = true;
        },
        deleteClose() {
            this.deleteTargetId = 0;
            this.deleteDialog = false;
        },
        deleteCustomer() {
            this.$axios
                .delete(`/api/v1/customer/${this.deleteTargetId}`)
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadList();
                    this.deleteClose();
                });
        },
    },
};
</script>
